<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="shopSerialId"
          table-no="mstShop"
          table-api="master/shop"
          ref="commonMasterTable"
          :editable="editableMixin.shop"
          :addable="editableMixin.shop"
          :mapping-no="`ie-shop`"
          socket-entity="SHOP_SOCKET"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/ShopMaster.vue